import React from 'react';
import intl from 'react-intl-universal';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  topOuterDivider: PropTypes.bool,
  topDivider: PropTypes.bool
}

const defaultProps = {
  topOuterDivider: false,
  topDivider: false
}

const Footer = ({
  className,
  topOuterDivider,
  topDivider,
  ...props
}) => {

  const classes = classNames(
    'site-footer center-content-mobile',
    topOuterDivider && 'has-top-divider',
    className
  );

  return (
    <footer
      {...props}
      className={classes}
    >
      <div className="container">
        <div className={
          classNames(
            'site-footer-inner has-top-divider',
            topDivider && 'has-top-divider'
          )}>
          <div className="space-between text-xxs">
            {intl.get('ADDRESS')}: 951 Mariners Island Blvd, Suite 300, San Mateo, CA 94404.
            {intl.get('EMAIL')}: info@digitalwoven.com
          </div>
          <div className="space-between text-xxs invert-order-desktop">
            <div className="footer-copyright">© 2020 DigitalWoven, Inc.</div>
          </div>
        </div>
      </div>
    </footer>
  );
}

Footer.propTypes = propTypes;
Footer.defaultProps = defaultProps;

export default Footer;